<template>
  <van-col span="24" style="position: relative">
    <!-- ✅ Блок загрузки при начальной загрузке -->
    <div v-if="isLoadingStatus" class="loading-block">
      <van-loading type="spinner" />
      <p class="loading-text">
        Будь ласка, зачекайте, завантаження інформації.
      </p>
    </div>

    <!-- ✅ Основной контент -->
    <div v-else>
      <!-- ✅ Overlay лоадер при отправке показаний или входе -->
      <div v-if="isSendingIndications" class="loading-overlay">
        <van-loading type="spinner" />
        <p class="loading-text">
          <span v-if="formStep === 3 || formStep === 4">
            Будь ласка, зачекайте...
          </span>
          <span v-else> Будь ласка, зачекайте, передача показань. </span>
        </p>
      </div>
      <!-- ШАГ 1: Форма отправки показаний -->
      <table v-if="formStep === 1" class="send-indications-table">
        <tr>
          <th class="apply-loader">
            {{ $t("regionalEnergy.sendIndications.previousIndications") }}
          </th>
          <th class="apply-loader">
            {{ $t("regionalEnergy.sendIndications.newIndications") }}
          </th>
        </tr>
        <tr>
          <td class="apply-loader">
            <div class="prev-ind-wrapper">
              {{ lastIndicators.svalue1 }}
            </div>
          </td>
          <td class="apply-loader">
            <input
              v-model.number="indications.value1"
              type="number"
              class="apply-loader dark-theme-input center-placeholder"
              :placeholder="$t('regionalEnergy.sendIndications.putIndications')"
            />
          </td>
        </tr>
      </table>

      <!-- ШАГ 2: Добавление договора -->
      <div v-if="formStep === 2" key="step2" class="credentials-inputs">
        <div class="info-text">
          {{ $t("regionalEnergy.sendIndications.noContractPrompt") }}
        </div>
        <input
          v-model="indications.contract_number"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.contractNumberPlaceholder')
          "
        />
        <input
          v-model="indications.meter_number"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.meterNumberPlaceholder')
          "
        />
      </div>

      <!-- ШАГ 3: Форма первого входа (регистрация) -->
      <div v-if="formStep === 3" key="step3" class="credentials-inputs">
        <div class="info-text">
          {{ $t("regionalEnergy.sendIndications.loginErrorPrompt") }}
        </div>
        <input
          v-model="indications.username"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.usernamePlaceholder')
          "
        />
        <input
          v-model="indications.password"
          type="password"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.passwordPlaceholder')
          "
        />
      </div>

      <!-- ШАГ 4: Форма повторного входа (неверные данные) -->
      <div v-if="formStep === 4" key="step4" class="credentials-inputs">
        <div class="info-text error-text">
          {{ $t("regionalEnergy.sendIndications.invalidCredentialsPrompt") }}
        </div>
        <input
          v-model="indications.username"
          type="text"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.usernamePlaceholder')
          "
        />
        <input
          v-model="indications.password"
          type="password"
          class="apply-loader dark-theme-input"
          :placeholder="
            $t('regionalEnergy.sendIndications.passwordPlaceholder')
          "
        />
      </div>

      <itserve-button
        type="primary"
        :value="buttonText"
        class="itserve-button-wide mt-15"
        @click="sendIndications"
      ></itserve-button>

      <!-- Кнопка регистрации для шагов 3 и 4 -->
      <itserve-button
        v-if="formStep === 3 || formStep === 4"
        type="secondary"
        :value="$t('regionalEnergy.sendIndications.registerButton')"
        class="itserve-button-wide mt-5"
        @click="openRegisterPage"
      ></itserve-button>

      <simple-dialog
        v-model="showDialog"
        :title="dialogMessage"
        :success="dialogSuccessMessage"
        @change="handleDialogClose"
      />

      <!-- Блок оценки приложения -->
      <div v-if="showRatingPrompt" class="rating-prompt">
        <p class="rating-text">
          {{ $t("regionalEnergy.sendIndications.rateAppPrompt") }}
        </p>
        <div class="rating-stars">★★★★★</div>
        <itserve-button
          type="primary"
          :value="$t('regionalEnergy.sendIndications.rateAppButton')"
          class="itserve-button-wide mt-15"
          @click="rateApp"
        ></itserve-button>
      </div>
    </div>
  </van-col>
</template>

<script>
import indications from "@/mixins/regional-energy/indications";
import SimpleDialog from "@/components/content/SimpleDialog";
import { Loading } from "vant";
import axios from "axios";

// Создаем настроенный клиент, который берет URL из .env файла
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_NEW_API_URL,
  timeout: 120000,
});

export default {
  components: { SimpleDialog, VanLoading: Loading },
  mixins: [indications],
  name: "SingleZoneStandart",
  props: {
    initialFormStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      formStep: this.initialFormStep,
      isLoadingStatus: false,
      isSendingIndications: false, // Флаг для показа лоадера при отправке показаний
      showRatingPrompt: false, // Флаг для показа блока оценки
      registerUrl: "https://pay.zakarpat.energy/home/user/register",
    };
  },
  computed: {
    buttonText() {
      if (this.formStep === 1)
        return this.$t("regionalEnergy.sendIndications.buttonSend");
      if (this.formStep === 2) return this.$t("buttons.addAccount");
      if (this.formStep === 3)
        return this.$t("regionalEnergy.sendIndications.buttonLogin");
      if (this.formStep === 4)
        return this.$t("regionalEnergy.sendIndications.buttonLogin");
      return this.$t("regionalEnergy.sendIndications.buttonSend");
    },
  },
  methods: {
    openRegisterPage() {
      this.nativeSendEvent("url", this.registerUrl);
    },
    rateApp() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Определение iOS
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.nativeSendEvent(
          "url",
          "https://apps.apple.com/ua/app/zakarpattya-energo/id6445990810"
        );
        return;
      }

      // Определение Android
      if (/android/i.test(userAgent)) {
        this.nativeSendEvent(
          "url",
          "https://play.google.com/store/apps/details?id=zakarpattya.energo&hl=uk"
        );
        return;
      }

      // Запасной вариант для десктопа и других ОС
      this.nativeSendEvent(
        "url",
        "https://play.google.com/store/apps/details?id=zakarpattya.energo&hl=uk"
      );
    },
    async performStep1() {
      const { username, password } = this.userCredentials;
      const reading = this.indications.value1;
      if (reading === null || reading === undefined || reading === "") {
        this.dialogMessage = this.$t(
          "regionalEnergy.sendIndications.enterReadings"
        );
        this.showDialog = true;
        return;
      }

      try {
        const payload = {
          username,
          password,
          account_id: this.indications.ls,
          reading: String(reading),
        };

        const response = await apiClient.post("send_meter", payload, {
          timeout: 120000,
        });

        if (response.data) {
          switch (response.data.status) {
            case "fail":
              // Проверяем, содержит ли сообщение "не найден"
              if (
                response.data.message &&
                (response.data.message.includes("не найден") ||
                  response.data.message.includes("не знайдено") ||
                  response.data.message.includes("not found"))
              ) {
                // Извлекаем номер договора из сообщения
                const match = response.data.message.match(/\d+/);
                const contractNumber = match ? match[0] : "";
                this.dialogMessage = this.$t(
                  "regionalEnergy.sendIndications.contractNotFoundWithNumber",
                  { number: contractNumber }
                );
              } else {
                this.dialogMessage =
                  response.data.message ||
                  this.$t("regionalEnergy.sendIndications.unknownError");
              }
              this.dialogSuccessMessage = false;
              this.showDialog = true;
              break;

            case "no_contract":
              this.dialogMessage = this.$t(
                "regionalEnergy.sendIndications.noContractFound"
              );
              this.dialogSuccessMessage = true;
              this.isNoContractError = true;
              this.showDialog = true;
              break;

            case "contract_exists":
              this.dialogMessage =
                response.data.message ||
                "Счета найдены, но показания не переданы";
              this.dialogSuccessMessage = false;
              this.showDialog = true;
              this.showRatingPrompt = true;
              break;

            case "success":
              this.dialogMessage = this.$t(
                "regionalEnergy.sendIndications.sentSuccessfullyFlow"
              );
              this.dialogSuccessMessage = true;
              this.showDialog = true;
              this.showRatingPrompt = true;
              break;

            default:
              this.dialogMessage =
                response.data.message ||
                this.$t("regionalEnergy.sendIndications.unknownError");
              this.dialogSuccessMessage = false;
              this.showDialog = true;
              break;
          }
        } else {
          this.dialogMessage = this.$t(
            "regionalEnergy.sendIndications.unknownError"
          );
          this.dialogSuccessMessage = false;
          this.showDialog = true;
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          this.$t("regionalEnergy.sendIndications.errorStep1");

        this.dialogMessage = errorMessage;
        this.dialogSuccessMessage = false;
        this.showDialog = true;
      }
    },
  },
};
</script>

<style scoped>
/* Стили для блока загрузки */
.loading-block {
  margin-top: 20vh;
  text-align: center;
}

/* Стили для overlay лоадера */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-text {
  color: #bdc3c7;
  margin-top: 15px;
  font-size: 16px;
}

.info-text {
  padding: 10px 15px;
  background-color: #2c3e50;
  color: #ecf0f1;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 0;
  text-align: center;
  font-size: 14px;
}
.credentials-inputs {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.prev-ind-wrapper {
  margin-top: 0px;
  color: #ecf0f1;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.send-indications-table {
  margin-top: 0;
}

.dark-theme-input {
  background-color: #2c3e50;
  color: #ecf0f1;
  border: 1px solid #34495e;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

/* Убираем стрелки из поля для ввода чисел */
.dark-theme-input::-webkit-outer-spin-button,
.dark-theme-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.dark-theme-input[type="number"] {
  -moz-appearance: textfield;
}

.dark-theme-input::placeholder {
  color: #95a5a6;
}

/* Центрируем плейсхолдер только для нужного поля */
.center-placeholder::placeholder {
  text-align: center;
}

table {
  width: 100%;
}
.send-indications-table th {
  font-size: 16px;
  color: #4277f5;
  padding-top: 3px;
  text-align: center;
}
.send-indications-table td {
  color: #0b0b0b;
  font-size: 16px;
  padding-top: 0px;
  width: 50%;
  text-align: center; /* Выравниваем содержимое по центру */
}
.loading-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  width: 100%;
  text-align: center;
}
.loading-block p {
  margin-top: 15px;
  color: #ecf0f1;
}

.rating-prompt {
  margin-top: 0px;
  text-align: center;
}

.rating-text {
  color: #ecf0f1;
  margin-bottom: 5px; /* Отступ до кнопки */
  padding: 0 15px; /* Горизонтальные отступы, чтобы текст не прилипал к краям */
  font-size: 15px;
}

.rating-stars {
  color: #f1c40f; /* gold */
  font-size: 25px; /* Уменьшил звезды */
  margin-left: 2px; /* Небольшой отступ от текста */
  vertical-align: middle; /* Выравнивание по центру строки */
}

:deep(.itserve-button-wide .front) {
  background: #4277f5 !important;
}
</style>
